const nf = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 1, minimumFractionDigits: 1 });
const money = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 });

export const fmt = (v) => (v === null || v === undefined || Number.isNaN(v) ? "—" : nf.format(v));
export const fmt1 = (v) => (v === null || v === undefined || Number.isNaN(v) ? "—" : nf1.format(v));
export const fmtMoney = (v) => (v === null || v === undefined || Number.isNaN(v) ? "—" : money.format(v));
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

// Same formula as Amazon's inventory template: stock / (avg(2wk/2, 3wk/3) / 7)
export const amazonDoh = (stock, two, three) => {
  if (!two) return stock > 0 ? 14 : 0;
  const daily = (two / 2 + three / 3) / 2 / 7;
  return daily ? stock / daily : 0;
};
